import { useCallback, useEffect, useState } from 'react';
import { fetchMetric } from '../api/dashboardService';
import { useDashboard } from '../context/DashboardContext';

/** Loads one dashboard metric. status: 'loading' | 'success' | 'empty' | 'error' */
export default function useMetric(key) {
  const { range, scenario } = useDashboard();
  const [state, setState] = useState({ status: 'loading', data: null, error: null });
  const [nonce, setNonce] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setState({ status: 'loading', data: null, error: null });
    fetchMetric(key, { range, scenario })
      .then(({ data }) => {
        if (cancelled) return;
        setState(data == null ? { status: 'empty', data: null, error: null } : { status: 'success', data, error: null });
      })
      .catch((error) => {
        if (!cancelled) setState({ status: 'error', data: null, error });
      });
    return () => {
      cancelled = true;
    };
  }, [key, range, scenario, nonce]);

  const retry = useCallback(() => setNonce((n) => n + 1), []);
  return { ...state, retry };
}
